import React, { useState, useEffect } from "react";
import NavLinks from "../Navbar/NavLinks";
import { HashLink } from "react-router-hash-link";
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";

import logo from "../../assets/images/Vero/Vero Logo.png";

const NavBar = () => {
    const logoSize = 80;
    const mobileLogoSize = 60;

    const [top, setTop] = useState(!window.scrollY);
    const [isOpen, setisOpen] = React.useState(false);
    function handleClick() {
        setisOpen(!isOpen);
    }
    function closeMenu() {
        setisOpen(false);
    }

    useEffect(() => {
        const scrollHandler = () => {
            window.pageYOffset > 10 ? setTop(false) : setTop(true);
        };
        window.addEventListener("scroll", scrollHandler);
        return () => window.removeEventListener("scroll", scrollHandler);
    }, [top]);

    return (
        <nav
            className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out mb-16 ${
                !top && "bg-white shadow-lg"
            }`}
        >
            <div className="flex flex-row justify-between items-center py-2">
                <div>
                    <BrowserView>
                        <div className="flex flex-row justify-center md:px-12 md:mx-12 items-center text-center font-semibold">
                            <HashLink smooth to="/#hero" className="d-flex align-items-center">
                                <img alt="Vero" src={logo} width={logoSize} height={logoSize} />
                                <h1 className="flex-0 font-extrabold text-4xl fg-primary ml-5">Vero</h1>
                            </HashLink>
                            <h2 className="flex-0 font-semibold fg-primary ml-20">
                                <span className="text-xl">Tax</span>
                                <span className="px-5">•</span>
                                <span className="text-xl">Accounting</span>
                                <span className="px-5">•</span>
                                <span className="text-xl">Advisory</span>
                            </h2>
                        </div>
                    </BrowserView>
                    <MobileView>
                        <div className="flex flex-row justify-center px-12 md:mx-12 items-center text-center font-semibold">
                            <HashLink smooth to="/#hero" className="d-flex align-items-center">
                                <img alt="Vero" src={logo} width={mobileLogoSize} height={mobileLogoSize} />
                                <h1 className="flex-0 font-extrabold text-4xl fg-primary ml-5">Vero</h1>
                            </HashLink>
                        </div>
                    </MobileView>
                </div>
                <div className="group flex flex-col items-center">
                    <BrowserView>
                        <div className="space-x-6 inline-block p-5">
                            <NavLinks />
                        </div>
                    </BrowserView>
                    <MobileView>
                        <button className="p-2 rounded-lg fg-primary" onClick={handleClick}>
                            <svg
                                className="h-6 w-6 fill-current"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                            >
                                {isOpen && (
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                                    />
                                )}
                                {!isOpen && (
                                    <path
                                        fillRule="evenodd"
                                        d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                                    />
                                )}
                            </svg>
                        </button>

                        <div
                            className={`fixed transition-transform duration-300 ease-in-out transit flex justify-center left-0 w-full h-auto rounded-md py-10 bg-white shadow-xl top-20 ${
                                isOpen ? "block" : "hidden"
                            } `}
                        >
                            <NavLinks onNavigate={closeMenu} />
                        </div>
                    </MobileView>
                </div>
            </div>
        </nav>
    );
};

export default NavBar;
